'use strict';

import { marked } from 'marked';
import angular from 'angular';

marked.use({ breaks: true, gfm: true });

var TMPL =
  '<div class="fed-root">' +
  '<div class="fed-toolbar">' +
    '<div class="fed-tb-group">' +
      '<button type="button" class="fed-tb-btn" ng-click="bold()" title="Gras (Ctrl+B)"><b>G</b></button>' +
      '<button type="button" class="fed-tb-btn" ng-click="italic()" title="Italique (Ctrl+I)"><i style="font-style:italic">I</i></button>' +
      '<button type="button" class="fed-tb-btn" ng-click="strike()" title="Barré"><s>S</s></button>' +
    '</div>' +
    '<span class="fed-tb-sep"></span>' +
    '<div class="fed-tb-group">' +
      '<button type="button" class="fed-tb-btn" ng-click="heading(1)" title="Titre 1" style="font-size:11px;font-weight:700">H1</button>' +
      '<button type="button" class="fed-tb-btn" ng-click="heading(2)" title="Titre 2" style="font-size:11px;font-weight:700">H2</button>' +
      '<button type="button" class="fed-tb-btn" ng-click="heading(3)" title="Titre 3" style="font-size:11px;font-weight:700">H3</button>' +
    '</div>' +
    '<span class="fed-tb-sep"></span>' +
    '<div class="fed-tb-group">' +
      '<button type="button" class="fed-tb-btn" ng-click="insertLink()" title="Lien"><i class="fa fa-link"></i></button>' +
      '<button type="button" class="fed-tb-btn" ng-click="insertImage()" title="Image"><i class="fa fa-image"></i></button>' +
    '</div>' +
    '<span class="fed-tb-sep"></span>' +
    '<div class="fed-tb-group">' +
      '<button type="button" class="fed-tb-btn" ng-click="code()" title="Code inline"><i class="fa fa-code"></i></button>' +
      '<button type="button" class="fed-tb-btn" ng-click="codeBlock()" title="Bloc de code"><i class="fa fa-file-code-o"></i></button>' +
      '<button type="button" class="fed-tb-btn" ng-click="quote()" title="Citation"><i class="fa fa-quote-right"></i></button>' +
    '</div>' +
    '<span class="fed-tb-sep"></span>' +
    '<div class="fed-tb-group">' +
      '<button type="button" class="fed-tb-btn" ng-click="ulist()" title="Liste à puces"><i class="fa fa-list-ul"></i></button>' +
      '<button type="button" class="fed-tb-btn" ng-click="olist()" title="Liste numérotée"><i class="fa fa-list-ol"></i></button>' +
    '</div>' +
    '<span class="fed-tb-sep"></span>' +
    '<div class="fed-tb-group">' +
      '<button type="button" class="fed-tb-btn" ng-click="table()" title="Tableau"><i class="fa fa-table"></i></button>' +
      '<button type="button" class="fed-tb-btn" ng-click="hr()" title="Séparateur" style="font-size:13px;letter-spacing:-2px">—</button>' +
    '</div>' +
    '<div class="fed-tabs">' +
      '<button type="button" class="fed-tab-btn" ng-class="{active: activeTab===\'write\'}" ng-click="setTab(\'write\')">Écrire</button>' +
      '<button type="button" class="fed-tab-btn" ng-class="{active: activeTab===\'preview\'}" ng-click="setTab(\'preview\')">Aperçu</button>' +
    '</div>' +
  '</div>' +
  '<textarea class="fed-textarea" ng-model="content" ng-show="activeTab===\'write\'" ' +
    'placeholder="{{placeholder || \'Écrivez ici... (Markdown supporté)\'}}"></textarea>' +
  '<div class="fed-preview md-body" ng-show="activeTab===\'preview\'" ng-bind-html="previewHtml">' +
    '<span class="fed-preview-empty" ng-if="!content">Rien à prévisualiser.</span>' +
  '</div>' +
  '<div class="fed-footer">' +
    '<span class="fed-hint"><i class="fa fa-info-circle"></i> **gras** &nbsp;*italique*&nbsp; `code`&nbsp; [lien](url)&nbsp; ![img](url)</span>' +
    '<span class="fed-chars" ng-class="{warn: (content||\'\').length > 4000}">{{(content || \'\').length}} car.</span>' +
  '</div>' +
  '</div>';

export default angular.module('observatoireApp')
  .directive('forumEditor', ['$sce', '$timeout', '$window', function($sce, $timeout, $window) {
    return {
      restrict: 'E',
      scope: { content: '=', placeholder: '@' },
      template: TMPL,
      link: function(scope, element) {
        scope.activeTab = 'write';
        scope.previewHtml = '';

        function ta() { return element[0].querySelector('textarea'); }

        function insert(before, def, after) {
          var el = ta(); if (!el) return;
          var s = el.selectionStart || 0, e = el.selectionEnd || 0;
          var v = scope.content || '';
          var sel = v.substring(s, e) || def;
          scope.content = v.substring(0, s) + before + sel + after + v.substring(e);
          $timeout(function() {
            el.focus();
            el.setSelectionRange(s + before.length, s + before.length + sel.length);
          });
        }

        function linePrefix(prefix) {
          var el = ta(); if (!el) return;
          var s = el.selectionStart || 0;
          var v = scope.content || '';
          var ls = v.lastIndexOf('\n', s - 1) + 1;
          var le = v.indexOf('\n', s); if (le === -1) le = v.length;
          var line = v.substring(ls, le);
          scope.content = v.substring(0, ls) + prefix + line + v.substring(le);
          $timeout(function() { el.focus(); el.setSelectionRange(ls + prefix.length, ls + prefix.length + line.length); });
        }

        scope.setTab = function(tab) {
          scope.activeTab = tab;
          if (tab === 'preview') {
            scope.previewHtml = $sce.trustAsHtml(marked.parse(scope.content || ''));
          }
        };

        scope.bold       = function() { insert('**', 'texte en gras', '**'); };
        scope.italic     = function() { insert('*', 'texte italique', '*'); };
        scope.strike     = function() { insert('~~', 'texte barré', '~~'); };
        scope.heading    = function(n) { linePrefix('#'.repeat(n) + ' '); };
        scope.code       = function() { insert('`', 'code', '`'); };
        scope.codeBlock  = function() { insert('\n```\n', 'code ici', '\n```\n'); };
        scope.quote      = function() { linePrefix('> '); };
        scope.ulist      = function() { linePrefix('- '); };
        scope.olist      = function() { linePrefix('1. '); };
        scope.hr         = function() { insert('\n\n---\n\n', '', ''); };
        scope.table      = function() {
          insert('\n| Colonne 1 | Colonne 2 | Colonne 3 |\n|-----------|-----------|----------|\n| Donnée    | Donnée    | Donnée    |\n', '', '');
        };
        scope.insertLink = function() {
          var url = $window.prompt('URL du lien :');
          if (url) insert('[', 'texte', '](' + url + ')');
        };
        scope.insertImage = function() {
          var url = $window.prompt('URL de l\'image :');
          if (url) insert('![', 'description', '](' + url + ')');
        };

        element.on('keydown', function(e) {
          if ((e.ctrlKey || e.metaKey)) {
            if (e.key === 'b' || e.key === 'B') { e.preventDefault(); scope.$apply(scope.bold); }
            if (e.key === 'i' || e.key === 'I') { e.preventDefault(); scope.$apply(scope.italic); }
          }
        });
      }
    };
  }]);
